export default __webpack_public_path__ + "static/Technology-Consulting-To-Fuel-Your-Business-Growth-b34051b54ff000eb4989eea93bd0d334.webp";